import { gql } from '@apollo/client';

export const GET_VOLUNTEER_FORM_SUBMISSIONS = gql`
  query GetVolunteerFormSubmissions($profileId: String!) {
    vm {
      profile(profileId: $profileId) {
        formSubmissions {
          formSubmissionId
          submissionDate
          form {
            formId
            title
          }
        }
      }
    }
  }
`;
